import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuthenticationStore } from 'Hooks/zustand/useAuthenticationStore';
import Navigation from 'Components/Navigation';
import { EventNames, EventTypes, trackEvent } from '@brighterion/insights';

import styles from './RootElement.css';

type RootElementProps = React.PropsWithChildren<{
    options: { isMastercardConnectUser: boolean };
}>;

const RootElement = ({ children, options: { isMastercardConnectUser } }: RootElementProps): React.ReactElement => {
    const { tenantKey } = useAuthenticationStore.getState().userInfo!;

    React.useEffect(() => {
        trackEvent({
            eventType: EventTypes.identify,
            eventName: EventNames.trackUser,
            payload: { userId: tenantKey }
        });
    }, [tenantKey]);

    return (
        <>
            <Helmet htmlAttributes={{ lang: 'en' }} titleTemplate='%s - Mastercard' defaultTitle='Rules Management'>
                <meta name='description' content='A Mastercard app' />
                <meta name='generator' content={process.env.MASTERCARD_PACKAGE_VERSION} />
            </Helmet>
            <header id='header' role='banner' className={styles.header}>
                {/**
                 * If user is using MC Connect initialize Connect Sidekick.
                 * Sidekick will render the <connect-header /> and <connect-footer />
                 */}
                {isMastercardConnectUser && <connect-header max-width={10000} />}
                <Navigation options={{ isMastercardConnectUser }} />
            </header>
            {children}
            {isMastercardConnectUser && <connect-footer max-width={10000} role='contentinfo' />}
        </>
    );
};

export default RootElement;
